import { Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor, HttpResponse } from '@angular/common/http';
import { Observable, of } from 'rxjs';
import { tap } from 'rxjs/operators';
import { MockBackendService } from '../services/mock-backend.service';

@Injectable()
export class MockBackendInterceptor implements HttpInterceptor {
  constructor(private mockBackend: MockBackendService) {}

  intercept(req: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    if (!this.mockBackend.shouldCache(req.url)) {
      return next.handle(req);
    }

    const key = this.mockBackend.createKey(req.method, req.urlWithParams, req.body);
    const cached = this.mockBackend.getFromStorage(key);

    if (cached) {
      console.log(`[MockCache] 📦 HIT: ${req.method} ${req.url}`);
      return of(new HttpResponse({ body: cached.body, status: cached.status }));
    }

    console.log(`[MockCache] 🌐 MISS: ${req.method} ${req.url}`);
    return next.handle(req).pipe(
      tap(event => {
        if (event instanceof HttpResponse && event.ok) {
          this.mockBackend.saveToStorage(key, event);
        }
      })
    );
  }
}
